var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 21.324,
    viewBox: "0 0 19.5 21.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-edit",
    transform: "translate(16102.75 23329.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.288,18.094a2.291,2.291,0,0,1-1.59-.6,2.382,2.382,0,0,1-.68-2.03l.37-3.24a3.605,3.605,0,0,1,.87-1.86l8.21-8.69c2.05-2.17,4.19-2.23,6.36-.18s2.23,4.19.18,6.36L7.8,16.544a3.6,3.6,0,0,1-1.81.97l-3.22.55C2.6,18.074,2.448,18.094,2.288,18.094Zm10.39-16.61a3.055,3.055,0,0,0-2.12,1.2l-8.21,8.7a2.309,2.309,0,0,0-.47,1l-.37,3.24a.879.879,0,0,0,.22.77.9.9,0,0,0,.78.18l3.22-.55a2.234,2.234,0,0,0,.97-.52l8.21-8.69c1.24-1.32,1.69-2.54-.12-4.24A3.162,3.162,0,0,0,12.678,1.484Z",
    transform: "translate(-16101.748 -23329.574)",
    fill: "#b44784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.188,6.648h-.07A6.859,6.859,0,0,1,.008.868a.762.762,0,0,1,.63-.86.762.762,0,0,1,.86.63,5.372,5.372,0,0,0,4.78,4.52.751.751,0,0,1,.67.82A.774.774,0,0,1,6.188,6.648Z",
    transform: "translate(-16093.848 -23326.697)",
    fill: "#b44784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M18.75,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h18a.755.755,0,0,1,.75.75A.755.755,0,0,1,18.75,1.5Z",
    transform: "translate(-16102.75 -23309.75)",
    fill: "#b44784"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/Icon-edit.1c498a88524e520aac4b485e10a1b821.svg";
export { ForwardRef as ReactComponent };